/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rtl_Text_FixedInputs */



/**
* | output |
* | --- |
* | "RTL text has been fixed." |
*
* @param {Rtl_Text_FixedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const rtl_text_fixed = /** @type {((inputs?: Rtl_Text_FixedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rtl_Text_FixedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le texte RTL a été corrigé.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Problem mit RTL-Text wurde behoben.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il testo RTL è stato corretto.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Исправлена ошибка в тексте, написанном справа налево.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se ha corregido el texto RTL.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("RTL文本已修复。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("RTLテキストが修正されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आरटीएल टेक्स्ट की समस्या ठीक कर दी गई है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O texto da direita para a esquerda foi corrigido.")
	return /** @type {LocalizedString} */ ("RTL text has been fixed.")
});